import { useAfcStore } from '@/Components/addFromCatalog/useAfcStore';
import type { PostsLoaderTypeKey, PostsLoaderTypes } from '@/Components/posts/loaders';
import RenderIfVisible from '@/Utility/RenderIfVisible';
import { Grid2 } from '@mui/material';
import { GridCard, type GridCardProps } from '../grid/GridCard';

// Separate to allow the use of useAddFromCatalogStore hook (no conditional hooks)
export const SelectView = <T extends PostsLoaderTypeKey>({
  data,
  gridProps,
  loadMore,
}: {
  data: Array<PostsLoaderTypes[T]['paginationNodeType']>;
  gridProps: (value: PostsLoaderTypes[T]['paginationNodeType']) => GridCardProps;
  loadMore?: () => void;
}) => {
  const selectedIds = useAfcStore((store) => store.selectedIds);
  const initIds = useAfcStore((store) => store.initIds);
  const afcType = useAfcStore((store) => store.afcType);
  const limit = useAfcStore((store) => store.limit);

  return (
    <Grid2 container className="GridContainer" justifyContent={'flex-start'} spacing={4}>
      {data.map((item, idx) => {
        const completeGridProps = gridProps(item);
        const isLast = completeGridProps.id === gridProps(data[data.length - 1]).id;

        if (!isLast && initIds?.some((id) => id === completeGridProps?.id)) return <></>;

        return (
          <RenderIfVisible
            key={`zngly_grid_list_grid_${idx.toString()}`}
            defaultHeight={350}
            fallback={
              <GridCard
                key={`zngly_grid_list_card_fallback_${idx.toString()}`}
                {...completeGridProps}
                node={item}
                select={
                  afcType ? { selectedIds, initIds, toType: afcType, limit, setStore: useAfcStore.setState } : undefined
                }
                isLast={false}
                isFallback={true}
              />
            }
            onChange={(isVisible) => {
              if (!isVisible || idx !== data.length - 1) return;
              loadMore?.();
            }}
            rootElement={<Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }} />}
          >
            <GridCard
              key={`zngly_grid_list_card_${idx.toString()}`}
              {...completeGridProps}
              node={item}
              select={
                afcType ? { selectedIds, initIds, toType: afcType, limit, setStore: useAfcStore.setState } : undefined
              }
              isLast={isLast}
            />
          </RenderIfVisible>
        );
      })}
    </Grid2>
  );
};

export default SelectView;
